<template>
  <section class="block">
    <p class="block-tips">购直播观看券送等价值鲸币499个，一经购买不支持退换。鲸币只能在App内使用，需在壹心理App观看直播。</p>
    <div class="block-btn" @click="goToCourse">
      <p>立即参加：{{ money }}元</p>
    </div>
  </section>
</template>

<script>
  export default {
    name: "JoinCourse",
    props: {
      lessonId: {
        type: Number,
        default: 0
      },
      money: {
        type: String,
        default: ''
      }
    },
    methods: {
      goToCourse() {
        let href = ''
        if (window.isYixinliApp) {
          href = `yixinli://open_lesson_detail?id=${this.lessonId}`
        } else {
          href = `${window.$liveApi['m-xy_url']}/lesson/${this.lessonId}`
        }
        window.location.href = href
      }
    }
  }
</script>

<style lang="scss" scoped>
  .block {
    background: #FFE6A0;
    border-radius: 20px 20px 0 0;
  }

  .block-tips {
    padding: 30px;
    font-size: 26px;
    color: #7D631D;
  }

  .block-btn {
    padding: 26px 0;
    background: #6982FA;
    border-radius: 20px 20px 0 0;

    font-size: 32px;
    color: #FFFFFF;
    font-weight: bold;
    text-align: center;
  }
</style>
